import Icon from '../components/Icon.vue'

Icon.register({
  shapes: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 320v160c0 17.7-14.3 32-32 32h-160c-17.7 0-32-14.3-32-32v-160c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32zM128 256c70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128 57.3-128 128-128zM479 224h-190.1c-25.3 0-41.2-26.7-28.5-48l95-160c12.7-21.3 44.3-21.3 57 0l95 160c12.7 21.3-3.2 48-28.5 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shapes.js
// module id = 1874
// module chunks = 0